import _ from 'lodash';

import React from "react";

import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";

// core components
import { SchemaForm, utils } from "components/material-ui-schema-form/index";
import GridContainer from "components/Grid/GridContainer.jsx";
import ItemGrid from "components/Grid/ItemGrid.jsx";

import withStyles from "material-ui/styles/withStyles";

import {createSpeaker} from "../../graph";
import Loading from "../../../etc/Loading";
import { createDemogKey, hasOnlyDigits } from "../../utils";
import Snackbar from "../CustomErrorSnackBar";

import {client} from "client";
import {emergencyNumbers} from "constants/EmergencyNumbers";


class Step3 extends React.Component {
  constructor(props) {
    super(props);

    this.conf = null;
    this.modelTemp = {};

    this.state = {
      schema: null,
      form: null,
      model: null,
      formState: "",
      keyState: 0, 
      formErrorMessage: ""
    };
  }

  componentDidMount() {
    this.conf = this.props.props.data.conf; 
  }
  
  // createSpeaker(pid, phonenumber, countryCode) {
  //   client.mutate({
  //     mutation: createSpeaker,
  //     variables: {
  //       pid: pid,
  //       phonenumber: phonenumber,
  //       countryCode: countryCode,
  //     }
  //   }).then((data) => {
  //     const resp = JSON.parse(data.data.createSpeaker.jsonObject);
  //     this.props.props.collectDataCallback('receiver_speakerid', resp.speakerId);
  //     this.props.props.collectDataCallback('receiver_speakerpk', resp.speakerPk);
  //   }).catch((data) => {
  //     this.props.props.collectDataCallback('receiver_speakerid', "");
  //   });
  // }

  onModelChange(key, val) {
    let newModel = this.state.model;
    utils.selectOrSet(key, newModel, val);
    this.setState({ model: newModel });

    let result = utils.validateBySchema(this.state.schema, this.state.model);

    if (result.valid){
      this.setState({formState: "success"});
      this.closeErrorSnackbar();
    } else
      this.setState({formState: null});
  }

  isValidated() {
    let region = 0;

    if (this.state.model.receiver_region)
      region = this.state.model.receiver_region;

    // this.createSpeaker(
    //   this.props.props.data.pid,
    //   parseInt(this.state.model.receiver_number),
    //   parseInt(this.state.model.receiver_countrycode)
    // )

    let age = parseInt(this.state.model.receiver_age);
    let cc = parseInt(this.state.model.receiver_countrycode);

    if (!hasOnlyDigits(this.state.model.receiver_number)) {
      this.openSnackBar("Phone Number should be a number", 1);
      return false;
    }

    if (cc) {
      let en = _.find(emergencyNumbers, {callingCode: parseInt(cc)});

      let num = this.state.model.receiver_number;
      let enFound = false;
      let enFNumber = "";

      for (const i in en.emergencyNumbers) {
        const l = en.emergencyNumbers[i].length;
        const valSplice = num.toString().slice(0, l);

        if (parseInt(en.emergencyNumbers[i]) === parseInt(valSplice)) {
          enFNumber = en.emergencyNumbers[i];
          enFound = true;
          break;
        }
      }

      if (enFound) {
        this.openSnackBar(`Emergency number found (${enFNumber})`, 1);
        return false;
      }
    }
    
    if (!age || !hasOnlyDigits(this.state.model.receiver_age)) {
      this.openSnackBar("Age should be a number", 1);
      return false;
    }
    else {
      const max = this.state.schema.properties.receiver_age.max;
      const min = this.state.schema.properties.receiver_age.min;

      if (age < min || age > max) {
        this.openSnackBar(`Age should be ${min}-${max}.`, 1);
        return false;
      }
    }

    if (this.state.formState === "success") {
      this.props.props.collectDataCallback('receiver', this.state.model);

      return true;
    } else {
      let result = utils.validateBySchema(this.state.schema, this.state.model);

      if (result.valid) {
        this.closeErrorSnackbar();
        this.props.props.collectDataCallback('receiver', this.state.model);
        return true;
      }
      else {
        this.openSnackBar(result)
      }
    }

    return false;
  }

  autoFillDemogFormData(propType, props, demogData) {
    const propsTitleToSkip = ["Carrier", "Country Code", "Number", "Speaker ID"];
    let i = 0;

    if (!demogData) {
      this.checkMirrors();
      return;
    }
    else if (demogData.length != (props.length-3)){
      i = this.state.keyState;
      this.setState({
        schema: this.conf["properties"]["receiver_props"],
        form: this.conf["properties"]["receiver_props"]["ui:order"],
        model: this.conf["form_data"]["receiver_props"],
        keyState: i + 1
      });

      this.checkMirrors();
      return;
    }

    const l = props.length;

    for (const prop in props) {
        let value = "";

        if (propsTitleToSkip.includes(props[prop]["title"])) {
            i++;
            continue;
        }

        if (props[prop]["title"] === "Age") {
            value += demogData.shift();
            value += demogData.shift();
        }
        else {
            if (props[prop]["enum"]) {
                const cpLength = props[prop]["enum"][0].toString().length;

                for (let x=0; x < cpLength; x++) {
                    value += demogData.shift();
                }
            }
            else {
                value += demogData.shift();
            }
        }

        if (props[prop]["type"] === "number")
            value = parseInt(value);

        const demogkey = createDemogKey(props[prop]);

        this.modelTemp[demogkey] = value;

        if(l - 1 === i) {
          let i = this.state.keyState;

          this.setState({
            schema: this.conf["properties"]["receiver_props"],
            form: this.conf["properties"]["receiver_props"]["ui:order"],
            model: this.modelTemp,
            keyState: i + 1
          });

          this.checkMirrors();
        }

        i++;
    }

    i = this.state.keyState;
    this.setState({
      schema: this.conf["properties"]["receiver_props"],
      form: this.conf["properties"]["receiver_props"]["ui:order"],
      model: this.modelTemp,
      keyState: i + 1
    });
  }

  clearData() {
    let i = this.state.keyState;
    this.modelTemp = {};
    this.props.props.collectDataCallback('receiver', {});
    
    this.setState({
      model: {},
      formState: null,
      keyState: i + 1
    });
  }

  clearAutoFillDemogs(schema) {
    const schemaOrder = schema["ui:order"];
    const schemaProperties = schema["properties"];

    for (let i in schemaOrder) {
      if (typeof schemaOrder[i] === "object") {
        this.conf["form_data"]["receiver_props"][schemaOrder[i]["key"]] = schemaProperties[schemaOrder[i]["key"]]["default"];
      }
      else {
        if (schemaProperties[schemaOrder[i]]["type"] === "string")
          this.conf["form_data"]["receiver_props"][schemaOrder[i]] = "";
        else
          this.conf["form_data"]["receiver_props"][schemaOrder[i]] = 0;
      }
    }
  }

  autoFillDemogs() {
    const data = this.props.props.getDataCallback("autoFill");
    const demogs = data["checkPin"]["pinlog"];
    const speakerOutline = data["checkPin"]["speakerOutline"];

    if (!demogs && !speakerOutline) {
      this.clearAutoFillDemogs(this.conf["properties"]["receiver_props"]);

      let i = this.state.keyState;

      this.setState({
        keyState: i + 1,
        schema: this.conf["properties"]["receiver_props"],
        form: this.conf["properties"]["receiver_props"]["ui:order"],
        model: this.conf["form_data"]["receiver_props"]
      });

      this.checkMirrors();
      return;
    }

    const receiverProps = _.sortBy(this.conf["properties"]["receiver_props"]["properties"], function(o) { return o.order });

    const receiverDemographic = demogs["demographicOutline"].toString().split("");

    if (speakerOutline) {
        // this.receiverNumberValue = speakerInline.phonenumber;
        this.modelTemp["receiver_number"] = speakerOutline.phonenumber.toString();
        this.modelTemp["receiver_speakerid"] = speakerOutline.speakerId;
    }

    this.modelTemp["receiver_carrier"] = '';
    this.modelTemp["receiver_countrycode"] = '';

    this.autoFillDemogFormData("receiver_props", receiverProps, receiverDemographic);
  }

  openSnackBar(message, type){
    if (type == 1) {
      this.setState({
        errorSnackbarOpen: true,
        formErrorMessage: `ERROR! -- ${message}`
      }); 
    }
    else {
      let dataPath = message.error.dataPath.replace('\/', '').replace('receiver_','');
      this.setState({
        errorSnackbarOpen: true, 
        formErrorMessage: `ERROR! -- ${dataPath}: ${message.error.message}`
      });
    }
  }

  closeErrorSnackbar(){
    this.setState({
      errorSnackbarOpen: false, 
    })
  }

  checkMirrors() {
    const callerData = this.props.props.getDataCallback("caller");
    const schema = this.conf["properties"]["receiver_props"]["properties"];
    for (const i in schema) {
      if (schema[i].mirror) {
        const row = schema[i];
        let keyName = row["title"].toLowerCase().replace(/[^a-zA-Z0-9]/g, ""); //remove special characters
        keyName = keyName.replace(" ", "_"); //replace spaces to underscore
        let reckeyName = `receiver_${keyName}`;
        let calkeyName = `caller_${keyName}`;
        try{
          this.conf["form_data"]["receiver_props"][reckeyName] = callerData[calkeyName];
        }
        catch(e) {
          console.log(e);
        }
      }
    }

    let x = this.state.keyState;
    this.setState({
      keyState: x + 1,
      schema: this.conf["properties"]["receiver_props"],
      form: this.conf["properties"]["receiver_props"]["ui:order"],
      model: this.conf["form_data"]["receiver_props"]
    });
  }

  render() {
    //need to change; ugly solution to know if next was clicked on wizard and step 3 is current page
    //this will handle the auto fill with the data coming from step 1 -ray
    if (this.props.props.getDataCallback("step3Next") === 1 ) {
      this.props.props.collectDataCallback("step3Next", 2);
      setTimeout(() => {
        if (!this.props.props.getDataCallback("step3FirstRender")) {
          this.autoFillDemogs();
          this.props.props.collectDataCallback("step3FirstRender", 2);
        }
        else {
          this.checkMirrors();
        }
      }, 0);
    }
    if (this.props.props.getDataCallback("clear3Data") === 1 ) {
      this.props.props.collectDataCallback("clear3Data", 2);
      setTimeout(() => {
        this.clearData();
      }, 0);
    }

    const { schema, form, model, keyState } = this.state;

    if (!schema && !form && !model)
      return (<Loading />);

    return (
      <GridContainer justify="center">
        <ItemGrid xs={12} sm={12}>
          <h4 style={{textAlign: "center"}}>
            Receiver Form
          </h4>
          
          <SchemaForm key={`receiverform-${keyState}`} schema={schema} form={form} model={model} onModelChange={this.onModelChange.bind(this)}/>
          <Snackbar 
            formErrorMessage={this.state.formErrorMessage}
            errorSnackbarOpen={this.state.errorSnackbarOpen}
            closeErrorSnackbar={this.closeErrorSnackbar.bind(this)}
          />
        </ItemGrid>
      </GridContainer>
    );
  }
}

export default withStyles(sweetAlertStyle)(Step3);


// WEBPACK FOOTER //
// ./src/views/callform/components/WizardSteps/Step3.jsx